import {
  Avatar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ForumPost from "../../components/ForumPost";
import MainLayout from "../../components/MainLayout";
import {
  LeftPane,
  RightPane,
  SplitViewContainer,
} from "../../components/SplitView";
import axiosInstance from "../../utils/axiosInstance";
import { useSidebarCounts } from "../../context/SidebarCountsContext";

export default function Forums() {
  const {updateCount, counts} = useSidebarCounts();

  const [pendingForums, setPendingForums] = useState([]);
  const [approvedForums, setApprovedForums] = useState([]);
  const [rejectedForums, setRejectedForums] = useState([]);
  const [topContributors, setTopContributors] = useState();
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const handleChange = (event, newValue) => {
    setCurrentIndex(newValue);
  };

  const fetchPendingForums = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/forums/pending`,
      );

      if (response.status === 200) {
        setPendingForums(response.data);
      }
    } catch (error) {}
  }, []);

  const fetchApprovedForums = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/forums/approved`,
      );

      if (response.status === 200) {
        setApprovedForums(response.data);
      }
    } catch (error) {}
  }, []);

  const fetchRejectedForums = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/forums/unapproved`,
      );

      if (response.status === 200) {
        setRejectedForums(response.data);
      }
    } catch (error) {}
  }, []);

  const fetchTopContributors = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/top-contributors`,
      );

      if (response.status === 200) {
        setTopContributors(response.data.contributors);
      }
    } catch (error) {}
  }, []);

  const handleUpdate = () => {
    fetchPendingForums();
    fetchApprovedForums();
    fetchRejectedForums();
    fetchTopContributors();
    updateCount();
  };

  useEffect(() => {
    fetchPendingForums();
    fetchApprovedForums();
    fetchRejectedForums();
    fetchTopContributors();
  }, [
    fetchApprovedForums,
    fetchPendingForums,
    fetchRejectedForums,
    fetchTopContributors,
  ]);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  return (
    <MainLayout>
      <Typography variant="h6">Forums</Typography>

      <SplitViewContainer>
        <LeftPane>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={currentIndex} onChange={handleChange}>
              <Tab label={`Pending ${counts.forums}`} />
              <Tab label="Approved" />
              <Tab label="Rejected" />
            </Tabs>
          </Box>

          {/* Pending */}
          <CustomTabPanel value={currentIndex} index={0}>
            {pendingForums && pendingForums.length > 0 ? (
              pendingForums.map((post, index) => (
                <ForumPost
                  key={index}
                  post={post}
                  onDelete={fetchPendingForums}
                  onUpdate={handleUpdate}
                />
              ))
            ) : (
              <Typography>There are no pending forum posts</Typography>
            )}
          </CustomTabPanel>

          {/* Approved */}
          <CustomTabPanel value={currentIndex} index={1}>
            {approvedForums && approvedForums.length > 0 ? (
              approvedForums.map((post, index) => (
                <ForumPost
                  key={index}
                  post={post}
                  onDelete={fetchApprovedForums}
                  onUpdate={handleUpdate}
                />
              ))
            ) : (
              <Typography>There are no approved forum posts</Typography>
            )}
          </CustomTabPanel>
          {/* Rejected */}
          <CustomTabPanel value={currentIndex} index={2}>
            {rejectedForums && rejectedForums.length > 0 ? (
              rejectedForums.map((post, index) => (
                <ForumPost
                  key={index}
                  post={post}
                  onDelete={fetchRejectedForums}
                  onUpdate={handleUpdate}
                />
              ))
            ) : (
              <Typography>There are no rejected forum posts</Typography>
            )}
          </CustomTabPanel>
        </LeftPane>

        <Divider orientation="vertical" />

        <RightPane>
          <Typography variant="h6" gutterBottom>
            Top Contributors
          </Typography>
          <List>
            {topContributors &&
              topContributors.map((contributor) => (
                <ListItem key={contributor.id}>
                  <ListItemAvatar>
                    <Avatar
                      src={`${process.env.REACT_APP_STORAGE_URL}/${contributor.profile_picture}`}
                      alt={contributor.full_name.charAt(0)}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={contributor.full_name}
                    secondary={`Total Points: ${contributor.total_points}`}
                  />
                </ListItem>
              ))}
          </List>
        </RightPane>
      </SplitViewContainer>
    </MainLayout>
  );
}
